import { TowerShow } from "../tower/TowerDetail";
import { TowerEdit, TowerList } from "../tower/towers";

const forcedCustomFields = ["resetTower", "releaseLockers"];

export const OrgTowersList = (props) => {
  return (
    <TowerList
      title="My Towers"
      forcedCustomFields={forcedCustomFields}
      filterDefaultValues={null}
      enableBulkCreate={false}
      omit={[]}
      {...props}
    />
  );
};

export const OrgTowerShow = () => {
  return <TowerShow />;
};

export const OrgTowerEdit = () => {
  return <TowerEdit />;
};
